import { useState } from "react";
import { useForm } from "react-hook-form";

import DashboardTemplate from "../../../templates/Dashboard";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Dropdown,
  Flex,
  Progress,
  Row,
  Switch,
  Tabs,
  TabsProps,
  Tag,
} from "antd";
import {
  AngleRight,
  ArrowRightIcon,
  ContractsIcon,
  ImageAddIcon,
  ImageRemoveIcon,
  NeedHelp,
} from "../../../atoms/CustomIcons";
import WorkReports from "./Tabs/WorkReports";
import WorkDetails from "./Tabs/WorkDetails";
import { SelectField } from "../../../atoms/FormFields";
import { MoreOutlined } from "@ant-design/icons";
import Materials from "./Tabs/Materials";
import Equipment from "./Tabs/Equipment";
import TimerIcon from "../../../atoms/CustomIcons/TimerIcon";
import JobCosting from "./Tabs/JobCosting";
import woDetail from "../DummyData/woDetail.json";

interface FormValues {
  choose_visit: string[];
}

export default function WorkOrderReport() {
  const [loading] = useState(false);
  const current = woDetail.progress.current;
  const total = woDetail.progress.total;
  const percent = (current / total) * 100;

  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];

  const { control } = useForm<FormValues>();
  const dummyOptions = [
    { label: "All visits", value: "All visits" },
    { label: "Visit 1", value: "1" },
    { label: "Visit 2", value: "2" },
    { label: "Visit 3", value: "3" },
  ];

  const tabItems: TabsProps["items"] = [
    {
      key: "1",
      label: "Work reports",
      children: <WorkReports />,
    },
    {
      key: "2",
      label: "Work details",
      children: <WorkDetails />,
    },
    {
      key: "3",
      label: "Materials",
      children: <Materials />,
    },
    {
      key: "4",
      label: "Equipment",
      children: <Equipment />,
    },
    {
      key: "5",
      label: "Job costing",
      children: <JobCosting />,
    },
  ];

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
          icon={<ImageRemoveIcon />}
        >
          Doesn’t require picture after
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
          icon={<ImageAddIcon />}
        >
          Requires picture after
        </Button>
      ),
    },
  ];

  console.log("woDetail", woDetail);

  return (
    <DashboardTemplate loading={loading}>
      <div className="forBackground">
        <Row gutter={[8, 8]} wrap={false}>
          <Col flex="366px" className="weeklyService">
            <Card>
              <Breadcrumb
                separator={<AngleRight />}
                style={{ marginBottom: "12px" }}
              >
                <Breadcrumb.Item>
                  <a href={`/work-orders/${companyId}`}> Work Orders </a>
                </Breadcrumb.Item>
                <Breadcrumb.Item>Weekly service</Breadcrumb.Item>
              </Breadcrumb>

              <div className="weeklyServiceWidget">
                <img src="/images/work-orders/landscape-demo.jpg" alt="" />
                <div className="overlay">
                  <div className="progress">
                    <Progress
                      type="dashboard"
                      percent={percent}
                      steps={32}
                      trailColor="#007F61"
                      strokeWidth={5}
                      strokeColor="#6AD3B7"
                      format={() => (
                        <>
                          <div
                            style={{
                              fontSize: 16,
                              fontWeight: "700",
                              color: "#fff",
                              marginBottom: 7,
                            }}
                          >
                            <span style={{ color: "#6AD3B7" }}>{current}</span>/{" "}
                            {total}
                          </div>
                          <div
                            style={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: "#fff",
                            }}
                          >
                            visits
                          </div>
                        </>
                      )}
                    />
                  </div>
                  <div className="progressDetail">
                    <h3>{woDetail.title}</h3>
                    <h6>{woDetail.description}</h6>
                    <div>
                      <Tag className="dark_purple_tag">{woDetail.status}</Tag>
                    </div>
                  </div>
                </div>
              </div>

              <h6
                style={{
                  marginBottom: "4px",
                  fontSize: "14px",
                  lineHeight: "20px",
                  fontWeight: "500",
                }}
              >
                Choose visit
              </h6>
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <SelectField
                  fieldName="choose_visit"
                  control={control}
                  selectOption={dummyOptions}
                  defaultValue={["All visits"]}
                  iProps={{
                    placeholder: "Choose visit",
                    mode: "multiple",
                  }}
                  className="fullWidthField"
                />

                <Dropdown
                  menu={{ items }}
                  trigger={["click"]}
                  className="actionButton"
                  placement="bottomRight"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    style={{
                      padding: "10px",
                      height: "36px",
                      width: "36px",
                      border: "1px solid #DEE5E6",
                      backgroundColor: "transparent",
                      borderRadius: "10px",
                    }}
                    className="status_dropdown"
                    icon={<MoreOutlined />}
                  />
                </Dropdown>
              </div>

              <div
                className="switchBox"
                style={{
                  fontWeight: "400",
                  justifyContent: "space-between",
                  marginBottom: "12px",
                }}
              >
                Requires approval <Switch checked={woDetail.requiresApproval} />
              </div>

              <div className="overallSummary">
                <Card style={{ borderRadius: "12px", marginBottom: "8px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "8px",
                    }}
                  >
                    <h4> Assignee </h4>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <img
                        src="/images/dummy/user.png"
                        alt=""
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "6px",
                        }}
                      />
                      <h4
                        style={{
                          fontSize: "12px",
                          lineHeight: "16px",
                          fontWeight: "600",
                        }}
                      >
                        {woDetail.assignee.crew} - {woDetail.assignee.name}
                      </h4>
                    </div>
                  </div>
                </Card>
                <Card style={{ borderRadius: "12px", marginBottom: "8px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "12px",
                    }}
                  >
                    <h4> Labor hours </h4>
                    <Button htmlType="button" className="outlined-btn btn-sm">
                      <TimerIcon /> Timesheets
                    </Button>
                  </div>
                  <Flex gap="small" vertical className="LabourProgressBar">
                    <Progress
                      percent={16}
                      success={{ percent: 15, strokeColor: "#00A07D" }}
                      strokeColor="#B2BDC2"
                      size={["100%", 32]}
                      style={{ borderRadius: "6px" }}
                    />

                    <div className="progressDetails">
                      <div className="mainBox">
                        <div className="leftTitle"> Actual </div>
                        <div className="rightTitle">
                          <span> 5% time saved </span> 3h 50m
                        </div>
                      </div>

                      <div className="mainBox">
                        <div className="leftTitle"> Estimated </div>
                        <div className="rightTitle"> 4h </div>
                      </div>
                      <div className="mainBox">
                        <div className="leftTitle">
                          Total estimated (all visits)
                        </div>
                        <div className="rightTitle"> 50h </div>{" "}
                      </div>
                    </div>
                  </Flex>
                </Card>

                <Card style={{ borderRadius: "12px" }}>
                  <h4> Property </h4>
                  <table
                    className="propertyTable"
                    style={{
                      borderCollapse: "separate",
                      borderSpacing: "0 12px",
                    }}
                  >
                    <tr>
                      <td className="TableTitle"> Property </td>
                      <td className="TableDescription">
                        {woDetail.propertyDetails.name} <ArrowRightIcon />
                      </td>
                    </tr>
                    <tr>
                      <td className="TableTitle"> Contract </td>
                      <td className="TableDescription">
                        {woDetail.propertyDetails.contract} <ArrowRightIcon />
                      </td>
                    </tr>

                    <tr>
                      <td className="TableTitle"> Contract dates </td>
                      <td className="TableDescription">
                        {woDetail.propertyDetails.contractDates}
                      </td>
                    </tr>
                    <tr>
                      <td className="TableTitle"> Production manager </td>
                      <td className="TableDescription">
                        <div className="tableImage">
                          <img
                            src={
                              woDetail.propertyDetails.productionManager
                                .imageUrl
                            }
                            alt=""
                            style={{ borderRadius: "100px" }}
                          />
                          {woDetail.propertyDetails.productionManager.name}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="TableTitle"> Account manager </td>
                      <td className="TableDescription">
                        <div className="tableImage">
                          <img
                            src={
                              woDetail.propertyDetails.accountManager.imageUrl
                            }
                            alt=""
                            style={{ borderRadius: "100px" }}
                          />
                          {woDetail.propertyDetails.accountManager.name}
                        </div>
                      </td>
                    </tr>
                  </table>
                </Card>
              </div>
            </Card>
          </Col>
          <Col flex="auto" className="serviceDetails">
            <Card>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3> Service details </h3>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "16px",
                  }}
                >
                  <Button className="btn-sm">
                    <NeedHelp /> Need help?
                  </Button>

                  <Button icon={<ContractsIcon />} className="outlined-btn">
                    Activity history
                  </Button>
                </div>
              </div>
              <Tabs
                defaultActiveKey="1"
                items={tabItems}
                className="workOrderTabs"
              />
            </Card>
          </Col>
        </Row>
      </div>
    </DashboardTemplate>
  );
}
